import {IssueClosedIcon, IssueOpenedIcon, SkipIcon} from '@primer/octicons-react'

export const VALUES = {
  issueIcons: {
    OPEN: {
      color: 'var(--fgColor-open)',
      icon: IssueOpenedIcon,
      description: 'Open issue',
    },
    CLOSED: {
      color: 'var(--fgColor-done)',
      icon: IssueClosedIcon,
      description: 'Closed issue (completed)',
    },
    NOT_PLANNED: {
      color: 'var(--fgColor-muted)',
      icon: SkipIcon,
      description: 'Closed issue (not planned)',
    },
  },
}
